import XLSX from "xlsx";
import hazmatController from "./hazmatController";
import { TrailerManifestUs } from "@routemax/hazmat";
class XlUtil {
  static readExcelFromBuffer = (fileInput) => {
    const readOptions = {
      type: "buffer",
      cellDates: false,
      cellText: false,
      cellNF: true,
      raw: true,
    };

    let workbook = XLSX.read(fileInput, readOptions);
    let sheet_name_list = workbook.SheetNames;
    let activeSheet = workbook.Sheets[sheet_name_list[0]];
    return XLSX.utils.sheet_to_json(activeSheet, {
      defval: "",
      raw: true,
      dateNF: "hh:mm:ss",
    });
  };

  static transformDataAndProcessFileUpload = (input) => {
    return new Promise((resolve, reject) => {
      try {
        const transformedData = input.map((record) => {
          return {
            ...record,
            pieces: parseInt(record.pieces),
            weight: parseInt(record.weight),
          };
        });

        const shipmentData = transformedData.map((data) => {
          return {
            proNumber: data.proNumber,
            isFood: data.isFood ? data.isFood.toLowerCase() : "false",
          };
        });

        const hazmatData = [];
        const errorsArr = [];

        const filteredHazmatData = transformedData.filter(
          (data) => data.unNumber
        );
        filteredHazmatData.forEach((data) => {
          if (
            !data.class ||
            !data.packageCode ||
            !data.pieces ||
            !data.weight
          ) {
            let errorObj = {
              ProNumber: data.proNumber,
              msg: "Invalid Data",
            };
            errorsArr.push(errorObj);
          } else {
            hazmatData.push({
              proNumber: data.proNumber,
              unNumber: data.unNumber,
              pgNumber: data.pgNumber,
              allowedToTransport: data.allowedToTransport,
              class: data.class,
              bulk: data.bulk,
              pieces: data.pieces,
              packageCode: data.packageCode,
              weight: data.weight,
            });
          }
        });

        const manifest = TrailerManifestUs.factory(
          // Shipment data of ALL shipments in the trailer, including non-hazmat shipments
          shipmentData,

          // Extended hazmat data of all hazmat shipments
          hazmatData
        );

        const result = hazmatController.analyze(manifest);
        result.placards.forEach((placard) => {
          if (placard.hazmatUnCodes && placard.hazmatUnCodes.length > 0)
            placard.hazmatUnCodes = placard.hazmatUnCodes.join(",");
        });
        let resultObj = {
          result,
          errorsArr,
        };
        resolve(resultObj);
      } catch (err) {
        reject(err);
      }
    });
  };
}

export default XlUtil;
